// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item ion-label {
  font-size: 14px;
  font-weight: 500;
}

ion-item ion-icon {
  font-size: 14px;
  color: #becae6;
  margin-inline-end: 10px;
  margin-top: 6px;
  margin-bottom: 6px;
}

.logo img {
  width: 190px;
}

ion-item {
  --min-height: 40px;
}

ion-accordion ion-list ion-item {
  border-bottom: none !important;
}

.ion-accordion-toggle-icon {
  font-size: 16px !important;
}

ion-button ion-label {
  font-size: 20px;
}

ion-button ion-icon {
  color: #a94eb5;
  padding-right: 5px;
  font-size: 14px;
}

.ion-accordion-toggle-icon {
  --margin-inline-start: 10px !important;
}

@media screen and (max-width: 992px) {
  /* Primary Blue Sidebar */
  .blue-menu {
    max-width: 50px !important;
    background: #fff;
    color: white;
    margin-top: 44px;
    border-right: none;
  }
  .white-menu {
    display: none; /* Hidden by default, shown programmatically */
  }
  .white-menu.show-menu {
    display: block !important;
  }
  .menu-list ion-item img {
    width: 30px !important;
    padding: 3px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .menu-list ion-item img {
    padding: 5px;
  }
  /* Primary Blue Sidebar */
  .blue-menu {
    width: 50px;
    background: #fff;
    color: white;
    margin-top: 44px;
    border-right: none;
  }
}
@media screen and (min-width: 993px) and (max-width: 1270px) {
  .menu-list ion-item img {
    padding: 7px;
  }
  /* Primary Blue Sidebar */
  .blue-menu {
    width: 50px;
    background: #fff;
    color: white;
    margin-top: 44px;
    border-right: none;
  }
}
@media screen and (min-width: 1271px) {
  .menu-list ion-item img {
    padding: 8px;
  }
  /* Primary Blue Sidebar */
  .blue-menu {
    width: 50px;
    background: #fff;
    color: white;
    margin-top: 44px;
    border-right: solid 1px #FFF;
  }
  /* Secondary White Sidebar */
  .white-menu {
    width: 155px;
    --background: #ffffff;
    color: black;
    margin-top: 60px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }
}
.submenu-list ion-item {
  cursor: pointer !important;
}

.menu-list {
  background: #e8e9eb;
  height: 100%;
}
.menu-list ion-item {
  --color: white;
  justify-content: center;
  margin: 8px 0;
}
.menu-list ion-item ion-icon {
  font-size: 24px;
}

ion-content {
  --background: #ffffff;
}

.submenu-list {
  padding: 0px;
  border-top: solid 1px #cfe1ff;
}
.submenu-list ion-item {
  --color: #333;
  --background-hover: rgba(0, 0, 0, 0.05);
  line-height: 23px;
}

/* Active Menu Item Style */
.active-item ion-icon {
  color: #FFF !important;
}

ion-button ion-text {
  text-transform: capitalize;
  font-size: 12px;
  font-weight: 400;
}

.submenu-list ion-item.active {
  --background: #f7faff;
  --font-weight: 600;
  color: #6030ff;
  border-right: none !important;
}

.selected-item {
  background-color: #fff !important;
  cursor: pointer !important;
}

.menu-list ion-item {
  --background: none !important;
  cursor: pointer !important;
  --text-align: center;
}

ion-menu ion-item ion-label {
  margin: 5px 0px !important;
}

ion-menu ion-item {
  --min-height: 34px;
}

.active-item {
  --background-color: #007bff !important;
  /* Change to your preferred color */
}

.settingMenu {
  position: absolute;
  bottom: 0px;
}

.logo p {
  margin-bottom: 0px !important;
  color: #a94eb5;
  font-size: 25px;
}

.submenu-list ion-item {
  border-bottom: solid 1px #cfe1ff;
}

.profileIcon ion-text {
  text-transform: lowercase;
}

.profileIcon ion-icon {
  color: #FFF;
  background: #a94eb5;
  padding: 5px;
  border-radius: 20px;
  margin-right: 5px;
}

.menu-start {
  margin-top: 63px;
}

.custom-menu {
  --background: #2c2f36;
  --color: #fff;
  width: 210px;
}
.custom-menu ion-content {
  --background: #0a193a;
}
.custom-menu ion-item {
  --background: #0a193a;
  --color: #e4e4e4;
  --padding-start: 16px;
  font-size: 15px;
}
.custom-menu ion-item ion-icon {
  margin-right: 10px;
  color: #bbb;
}
.custom-menu ion-item.active {
  background: #1f2228;
}
.custom-menu ion-item.active ion-icon {
  color: #4dabf7;
}
.custom-menu .submenu {
  background: #0e2046;
}
.custom-menu .submenu ion-item {
  font-size: 14px;
  --color: #ccc;
  padding-left: 14px;
  background: #0a193a;
}
.custom-menu .submenu ion-item.active {
  --color: #0a193a;
  --background: #fff;
}
.custom-menu ion-list {
  background: #2c2f36;
  padding-top: 0px;
  padding-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./../../omnichannel%20frontend%20before%20nikhils%20api%20added/omnichannel/src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;ACCF;;ADEA;EACE,eAAA;EACA,cAAA;EAEA,uBAAA;EACA,eAAA;EACA,kBAAA;ACAF;;ADGA;EACE,YAAA;ACAF;;ADGA;EACE,kBAAA;ACAF;;ADKA;EACE,8BAAA;ACFF;;ADKA;EACE,0BAAA;ACFF;;ADKA;EACE,eAAA;ACFF;;ADKA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;ACFF;;ADKA;EACE,sCAAA;ACFF;;ADMA;EAEE,yBAAA;EACA;IACE,0BAAA;IAEA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;ECLF;EDSA;IACE,aAAA,EAAA,8CAAA;ECPF;EDUA;IACE,yBAAA;ECRF;EDWE;IACI,sBAAA;IACA,YAAA;ECTN;AACF;ADaA;EACE;IACE,YAAA;ECXF;EDcA,yBAAA;EACA;IACE,WAAA;IAEA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;ECbF;AACF;ADiBA;EACE;IACE,YAAA;ECfF;EDkBA,yBAAA;EACA;IACE,WAAA;IAEA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;ECjBF;AACF;ADqBA;EACE;IACE,YAAA;ECnBF;EDsBA,yBAAA;EACA;IACE,WAAA;IAEA,gBAAA;IACA,YAAA;IACA,gBAAA;IACD,4BAAA;ECrBD;EDyBA,4BAAA;EACA;IACE,YAAA;IACA,qBAAA;IACA,YAAA;IACA,gBAAA;IACA,yCAAA;ECvBF;AACF;AD0BA;EACE,0BAAA;ACxBF;;AD2BA;EACE,mBAAA;EACA,YAAA;ACxBF;AD0BE;EACE,cAAA;EACA,uBAAA;EACA,aAAA;ACxBJ;AD0BI;EACE,eAAA;ACxBN;;ADgCA;EACE,qBAAA;AC7BF;;ADgCA;EACE,YAAA;EACA,6BAAA;AC7BF;AD+BE;EACE,aAAA;EACA,uCAAA;EACA,iBAAA;AC7BJ;;ADkCA,2BAAA;AACA;EACE,sBAAA;AC/BF;;ADkCA;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AC/BF;;ADkCA;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AC/BF;;ADkCA;EACE,iCAAA;EACA,0BAAA;AC/BF;;ADkCA;EACE,6BAAA;EACA,0BAAA;EACA,oBAAA;AC/BF;;ADkCA;EACE,0BAAA;AC/BF;;ADkCA;EACE,kBAAA;AC/BF;;ADmCA;EACE,sCAAA;EACA,mCAAA;AChCF;;ADmCA;EACE,kBAAA;EACA,WAAA;AChCF;;ADmCA;EACE,6BAAA;EACA,cAAA;EACE,eAAA;AChCJ;;ADmCA;EACM,gCAAA;AChCN;;ADmCA;EACE,yBAAA;AChCF;;ADmCA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AChCF;;ADmCA;EACE,gBAAA;AChCF;;ADmCA;EACE,qBAAA;EACA,aAAA;EACA,YAAA;AChCF;ADkCE;EACE,qBAAA;AChCJ;ADmCE;EACE,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;ACjCJ;ADmCI;EACE,kBAAA;EACA,WAAA;ACjCN;ADoCI;EACE,mBAAA;AClCN;ADmCM;EACE,cAAA;ACjCR;ADsCE;EACE,mBAAA;ACpCJ;ADsCI;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;ACpCN;ADuCI;EACE,gBAAA;EACA,kBAAA;ACrCN;ADyCE;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;ACvCJ","sourcesContent":["ion-item ion-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\nion-item ion-icon {\r\n  font-size: 14px;\r\n  color: #becae6;\r\n  //background-image: linear-gradient(160deg, var(--gradient-1), var(--gradient-1), var(--gradient-2), var(--gradient-3));\r\n  margin-inline-end: 10px;\r\n  margin-top: 6px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.logo img {\r\n  width: 190px;\r\n}\r\n\r\nion-item {\r\n  --min-height: 40px;\r\n  \r\n}\r\n\r\n\r\nion-accordion ion-list ion-item {\r\n  border-bottom: none !important;\r\n}\r\n\r\n.ion-accordion-toggle-icon {\r\n  font-size: 16px !important;\r\n}\r\n\r\nion-button ion-label {\r\n  font-size: 20px;\r\n}\r\n\r\nion-button ion-icon {\r\n  color: #a94eb5;\r\n  padding-right: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.ion-accordion-toggle-icon {\r\n  --margin-inline-start: 10px !important;\r\n}\r\n\r\n\r\n@media screen and (max-width:992px) {\r\n\r\n  /* Primary Blue Sidebar */\r\n  .blue-menu {\r\n    max-width: 50px !important;\r\n    // background: #506ee4;\r\n    background: #fff;\r\n    color: white;\r\n    margin-top: 44px;\r\n    border-right: none;\r\n\r\n  }\r\n\r\n  .white-menu {\r\n    display: none; /* Hidden by default, shown programmatically */\r\n  }\r\n\r\n  .white-menu.show-menu {\r\n    display: block !important;\r\n  }\r\n\r\n    .menu-list ion-item img {\r\n        width: 30px !important;\r\n        padding: 3px\r\n    }\r\n  \r\n}\r\n\r\n@media screen and (min-width:992px) and (max-width:1200px) {\r\n  .menu-list ion-item img {\r\n    padding: 5px;\r\n  }\r\n\r\n  /* Primary Blue Sidebar */\r\n  .blue-menu {\r\n    width: 50px;\r\n    // background: #506ee4;\r\n    background: #fff;\r\n    color: white;\r\n    margin-top: 44px;\r\n    border-right: none;\r\n\r\n  }\r\n}\r\n\r\n@media screen and (min-width:993px) and (max-width:1270px) {\r\n  .menu-list ion-item img {\r\n    padding: 7px;\r\n  }\r\n\r\n  /* Primary Blue Sidebar */\r\n  .blue-menu {\r\n    width: 50px;\r\n    // background: #506ee4;\r\n    background: #fff;\r\n    color: white;\r\n    margin-top: 44px;\r\n    border-right: none;\r\n\r\n  }\r\n}\r\n\r\n@media screen and (min-width:1271px) {\r\n  .menu-list ion-item img {\r\n    padding: 8px;\r\n  }\r\n\r\n  /* Primary Blue Sidebar */\r\n  .blue-menu {\r\n    width: 50px;\r\n    // background: #506ee4;\r\n    background: #fff;\r\n    color: white;\r\n    margin-top: 44px;\r\n   border-right: solid 1px #FFF;\r\n\r\n  }\r\n\r\n  /* Secondary White Sidebar */\r\n  .white-menu {\r\n    width: 155px;\r\n    --background: #ffffff;\r\n    color: black;\r\n    margin-top: 60px;\r\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n}\r\n\r\n.submenu-list ion-item {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.menu-list {\r\n  background: #e8e9eb;\r\n  height: 100%;\r\n\r\n  ion-item {\r\n    --color: white;\r\n    justify-content: center;\r\n    margin: 8px 0;\r\n\r\n    ion-icon {\r\n      font-size: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\nion-content {\r\n  --background: #ffffff;\r\n}\r\n\r\n.submenu-list {\r\n  padding: 0px;\r\n  border-top: solid 1px #cfe1ff;\r\n\r\n  ion-item {\r\n    --color: #333;\r\n    --background-hover: rgba(0, 0, 0, 0.05);\r\n    line-height: 23px;\r\n  }\r\n}\r\n\r\n\r\n/* Active Menu Item Style */\r\n.active-item ion-icon {\r\n  color: #FFF !important;\r\n}\r\n\r\nion-button ion-text {\r\n  text-transform: capitalize;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n}\r\n\r\n.submenu-list ion-item.active {\r\n  --background: #f7faff;\r\n  --font-weight: 600;\r\n  color: #6030ff;\r\n  border-right: none !important;\r\n}\r\n\r\n.selected-item {\r\n  background-color: #fff !important; // Change to your preferred color\r\n  cursor: pointer !important;\r\n}\r\n\r\n.menu-list ion-item {\r\n  --background: none !important;\r\n  cursor: pointer !important;\r\n  --text-align: center;\r\n}\r\n\r\nion-menu ion-item ion-label {\r\n  margin: 5px 0px !important;\r\n}\r\n\r\nion-menu ion-item {\r\n  --min-height: 34px;\r\n}\r\n\r\n\r\n.active-item {\r\n  --background-color: #007bff !important;\r\n  /* Change to your preferred color */\r\n}\r\n\r\n.settingMenu {\r\n  position: absolute;\r\n  bottom: 0px;\r\n}\r\n\r\n.logo p {\r\n  margin-bottom: 0px !important;\r\n  color: #a94eb5;\r\n    font-size: 25px;\r\n}\r\n\r\n.submenu-list ion-item {\r\n      border-bottom: solid 1px #cfe1ff;\r\n}\r\n\r\n.profileIcon ion-text {\r\n  text-transform: lowercase;\r\n}\r\n\r\n.profileIcon ion-icon {\r\n  color: #FFF;\r\n  background: #a94eb5;\r\n  padding: 5px;\r\n  border-radius: 20px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.menu-start {\r\n  margin-top: 63px;\r\n}\r\n\r\n.custom-menu {\r\n  --background: #2c2f36;\r\n  --color: #fff;\r\n  width: 210px;\r\n\r\n  ion-content {\r\n    --background: #0a193a;\r\n  }\r\n\r\n  ion-item {\r\n    --background: #0a193a;\r\n    --color: #e4e4e4;\r\n    --padding-start: 16px;\r\n    font-size: 15px;\r\n\r\n    ion-icon {\r\n      margin-right: 10px;\r\n      color: #bbb;\r\n    }\r\n\r\n    &.active {\r\n      background: #1f2228;\r\n      ion-icon {\r\n        color: #4dabf7;\r\n      }\r\n    }\r\n  }\r\n\r\n  .submenu {\r\n    background: #0e2046;\r\n\r\n    ion-item {\r\n      font-size: 14px;\r\n      --color: #ccc;\r\n      padding-left: 14px;\r\n      background: #0a193a;\r\n    }\r\n\r\n    ion-item.active {\r\n      --color: #0a193a;\r\n      --background: #fff;\r\n    }\r\n  }\r\n\r\n  ion-list {\r\n    background: #2c2f36;\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n  }\r\n}\r\n","ion-item ion-label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\nion-item ion-icon {\n  font-size: 14px;\n  color: #becae6;\n  margin-inline-end: 10px;\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n\n.logo img {\n  width: 190px;\n}\n\nion-item {\n  --min-height: 40px;\n}\n\nion-accordion ion-list ion-item {\n  border-bottom: none !important;\n}\n\n.ion-accordion-toggle-icon {\n  font-size: 16px !important;\n}\n\nion-button ion-label {\n  font-size: 20px;\n}\n\nion-button ion-icon {\n  color: #a94eb5;\n  padding-right: 5px;\n  font-size: 14px;\n}\n\n.ion-accordion-toggle-icon {\n  --margin-inline-start: 10px !important;\n}\n\n@media screen and (max-width: 992px) {\n  /* Primary Blue Sidebar */\n  .blue-menu {\n    max-width: 50px !important;\n    background: #fff;\n    color: white;\n    margin-top: 44px;\n    border-right: none;\n  }\n  .white-menu {\n    display: none; /* Hidden by default, shown programmatically */\n  }\n  .white-menu.show-menu {\n    display: block !important;\n  }\n  .menu-list ion-item img {\n    width: 30px !important;\n    padding: 3px;\n  }\n}\n@media screen and (min-width: 992px) and (max-width: 1200px) {\n  .menu-list ion-item img {\n    padding: 5px;\n  }\n  /* Primary Blue Sidebar */\n  .blue-menu {\n    width: 50px;\n    background: #fff;\n    color: white;\n    margin-top: 44px;\n    border-right: none;\n  }\n}\n@media screen and (min-width: 993px) and (max-width: 1270px) {\n  .menu-list ion-item img {\n    padding: 7px;\n  }\n  /* Primary Blue Sidebar */\n  .blue-menu {\n    width: 50px;\n    background: #fff;\n    color: white;\n    margin-top: 44px;\n    border-right: none;\n  }\n}\n@media screen and (min-width: 1271px) {\n  .menu-list ion-item img {\n    padding: 8px;\n  }\n  /* Primary Blue Sidebar */\n  .blue-menu {\n    width: 50px;\n    background: #fff;\n    color: white;\n    margin-top: 44px;\n    border-right: solid 1px #FFF;\n  }\n  /* Secondary White Sidebar */\n  .white-menu {\n    width: 155px;\n    --background: #ffffff;\n    color: black;\n    margin-top: 60px;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n  }\n}\n.submenu-list ion-item {\n  cursor: pointer !important;\n}\n\n.menu-list {\n  background: #e8e9eb;\n  height: 100%;\n}\n.menu-list ion-item {\n  --color: white;\n  justify-content: center;\n  margin: 8px 0;\n}\n.menu-list ion-item ion-icon {\n  font-size: 24px;\n}\n\nion-content {\n  --background: #ffffff;\n}\n\n.submenu-list {\n  padding: 0px;\n  border-top: solid 1px #cfe1ff;\n}\n.submenu-list ion-item {\n  --color: #333;\n  --background-hover: rgba(0, 0, 0, 0.05);\n  line-height: 23px;\n}\n\n/* Active Menu Item Style */\n.active-item ion-icon {\n  color: #FFF !important;\n}\n\nion-button ion-text {\n  text-transform: capitalize;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.submenu-list ion-item.active {\n  --background: #f7faff;\n  --font-weight: 600;\n  color: #6030ff;\n  border-right: none !important;\n}\n\n.selected-item {\n  background-color: #fff !important;\n  cursor: pointer !important;\n}\n\n.menu-list ion-item {\n  --background: none !important;\n  cursor: pointer !important;\n  --text-align: center;\n}\n\nion-menu ion-item ion-label {\n  margin: 5px 0px !important;\n}\n\nion-menu ion-item {\n  --min-height: 34px;\n}\n\n.active-item {\n  --background-color: #007bff !important;\n  /* Change to your preferred color */\n}\n\n.settingMenu {\n  position: absolute;\n  bottom: 0px;\n}\n\n.logo p {\n  margin-bottom: 0px !important;\n  color: #a94eb5;\n  font-size: 25px;\n}\n\n.submenu-list ion-item {\n  border-bottom: solid 1px #cfe1ff;\n}\n\n.profileIcon ion-text {\n  text-transform: lowercase;\n}\n\n.profileIcon ion-icon {\n  color: #FFF;\n  background: #a94eb5;\n  padding: 5px;\n  border-radius: 20px;\n  margin-right: 5px;\n}\n\n.menu-start {\n  margin-top: 63px;\n}\n\n.custom-menu {\n  --background: #2c2f36;\n  --color: #fff;\n  width: 210px;\n}\n.custom-menu ion-content {\n  --background: #0a193a;\n}\n.custom-menu ion-item {\n  --background: #0a193a;\n  --color: #e4e4e4;\n  --padding-start: 16px;\n  font-size: 15px;\n}\n.custom-menu ion-item ion-icon {\n  margin-right: 10px;\n  color: #bbb;\n}\n.custom-menu ion-item.active {\n  background: #1f2228;\n}\n.custom-menu ion-item.active ion-icon {\n  color: #4dabf7;\n}\n.custom-menu .submenu {\n  background: #0e2046;\n}\n.custom-menu .submenu ion-item {\n  font-size: 14px;\n  --color: #ccc;\n  padding-left: 14px;\n  background: #0a193a;\n}\n.custom-menu .submenu ion-item.active {\n  --color: #0a193a;\n  --background: #fff;\n}\n.custom-menu ion-list {\n  background: #2c2f36;\n  padding-top: 0px;\n  padding-bottom: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
